<template>
    <img src="/logo.png" alt="LinkPrint Factory System" class="">
</template>
